import { Fragment, Suspense, useState, useEffect } from 'react';
import { useIsMutating, useIsFetching } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Home from '../views/home';
import { setTenantData } from '../store/tenant.slice';
import { setTenantSlug } from '../store/tenantSlug.slice';
import { useQuery } from '@tanstack/react-query';
import instance from '../axios-instance';
import { storeDataInIndexedDB } from '@jadwalh/utils';

export default function Layout() {
  /* ------------------------------- Global State ------------------------------ */
  const { client, tenantSlug } = useParams();
  /* ---------------------------------- Hooks --------------------------------- */
  const dispatch = useDispatch();

  // Store tenant slug in Redux for use in API calls
  useEffect(() => {
    if (tenantSlug) {
      dispatch(setTenantSlug(tenantSlug));
    } else {
      dispatch(setTenantSlug(''));
    }
  }, [tenantSlug, dispatch]);

  /* --------------------------------- Effects -------------------------------- */

  //extract the subdomain from the url

  const { data: languageData } = useQuery({
    queryKey: ['languageData'],
    queryFn: () => instance.get('/app/languages'),
    select: (res: any): { value: string; label: string }[] =>
      res.data.data.map((item: any) => ({
        value: item.id.toString(),
        label: item.name,
      })),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const { data: countryData } = useQuery({
    queryKey: ['countryData'],
    queryFn: () => instance.get('/app/countries'),
    select: (res: any): { value: string; label: string }[] =>
      res.data.data.map((item: any) => ({
        value: item.id.toString(),
        label: item.name,
      })),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (languageData && countryData) {
      storeDataInIndexedDB(languageData, countryData);
    }
  }, [languageData, countryData]);

  //fetch the tenant data
  const { data } = useQuery({
    queryKey: ['tenant', tenantSlug],
    queryFn: () => {
      // Build the API URL based on whether tenant slug exists
      const apiPath = tenantSlug
        ? `/${tenantSlug}/tenant?settings[0]=reservation_info&settings[1]=reservation_identity&settings[2]=reservation_cancellation_policy`
        : `/tenant/${client}?settings[0]=reservation_info&settings[1]=reservation_identity&settings[2]=reservation_cancellation_policy`;

      return instance.get(apiPath);
    },
    retry: false,
    refetchOnWindowFocus: false,
    select: (res : any) => res.data.data,
    onSuccess: (data: any) => {
      dispatch(setTenantData({ name: data.name, settings: data.settings }));
      if (data.name) {
        document.title = data.name;
      }
    },
    enabled: tenantSlug ? !!tenantSlug : !!client,
  });

  return (
    <Suspense fallback={<div></div>}>
      <Home />
    </Suspense>
  );
}
